module.exports = __webpack_public_path__ + "static/media/2.6474712d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row5/2.wav
// module id = 87
// module chunks = 0